import { useReducer } from 'react';
import IAppState from './AppState';
import AppAction from './AppAction';

const reducer = (state: IAppState, action: AppAction): IAppState => {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        user: action.payload.user,
      };
    case 'AUTHORIZE':
      return {
        ...state,
        authorized: true,
        isCheckingAuth: false,
      };
    case 'UNAUTHORIZE':
      return {
        ...state,
        user: null,
        authorized: false,
        isCheckingAuth: false,
      };
    case 'SHOW_NOTIFICATION':
      return {
        ...state,
        notification: action.payload.notification,
      };
    case 'CLEAR_NOTIFICATION':
      return {
        ...state,
        notification: null,
      };

    default:
      return state;
  }
};

export const initialAppState: IAppState = {
  isCheckingAuth: true,
  authorized: false,
  user: null,
  notification: null,
};

const useAppReducer = () => useReducer(reducer, initialAppState);

export default useAppReducer;
